export const support = {
  title: "Suporte",
  subtitle: "Obtenha ajuda do nosso time de suporte",
  tickets: {
    title: "Tickets",
    create: "Criar Ticket",
    createFree: "Apenas para clientes pagos",
    status: {
      OPEN: "Aberto",
      IN_PROGRESS: "Em Andamento",
      RESOLVED: "Resolvido",
      CLOSED: "Fechado",
    },
    priority: {
      LOW: "Baixa",
      MEDIUM: "Média",
      HIGH: "Alta",
      URGENT: "Urgente",
    },
    table: {
      title: "Título",
      status: "Status",
      client: "Cliente",
      priority: "Prioridade",
      createdAt: "Criado em",
      lastUpdate: "Última atualização",
      actions: "Ações",
    },
    actions: {
      view: "Visualizar",
      reply: "Responder",
      close: "Fechar",
      changePriority: "Alterar Prioridade",
    },
    modal: {
      title: "Novo Ticket",
      titleLabel: "Brevemente descreva seu problema ou pergunta",
      titlePlaceholder: "Brevemente descreva seu problema ou pergunta",
      descriptionLabel: "Descreva seu problema ou pergunta em detalhes",
      descriptionPlaceholder: "Descreva seu problema ou pergunta em detalhes",
      priorityLabel: "Prioridade",
      priority: {
        low: "Baixa",
        medium: "Média",
        high: "Alta",
        urgent: "Urgente",
      },
      submit: "Enviar",
    },
  },
  detail: {
    description: "Descrição",
    conversation: "Conversação",
    created: "Criado em {{date}}",
    replyPlaceholder: "Escreva sua resposta aqui",
    user: "Você",
    staff: "Equipe",
    send: "Enviar",
    success: {
      messageSent: "Mensagem enviada com sucesso",
    },
    error: {
      loading: "Erro ao carregar o ticket",
      sending: "Erro ao enviar mensagem",
    },
  },
};
